import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState, useRef } from 'react'
import './styles/players.css'

//Components
import Loader from '../components/loader'
import Snack from '../components/snack'
import Confirm from '../components/confirm'
import TicketModal from '../components/ticketmodal'
import Menu from '../components/menu'
import LogoTicket from '../assets/images/logo-ticket.png'
import Player from './components/PlayerRow'
import { IoPersonAddOutline } from "react-icons/io5"
import { LiaUserSlashSolid } from "react-icons/lia"
import { RxReset } from "react-icons/rx"

//Extras
import { fontType, main } from '../assets/extras'
import { getCurrentDate } from '../assets/validator'
import { categorias, niveles } from '../assets/datas'
import { formatQuantity, validatePayment, PAYMENT_COLORS } from './utils/paymentUtils'
import { deletingPlayer, bajaJugador as bajaJugadorAction, updateAssistances, updatingPlayer, addPaymentHistory, addNewFinance, generateSuscriptionXLSX, handleCreateXLSX } from './utils/playerActions'
import usePlayersData from './hooks/usePlayersData'
import CryptoJS from 'crypto-js'

const Players = () => {

    const navigate = useNavigate()

    const location = useLocation()
    const ref = location.state ? location.state.ref : null
    const academia = location.state ? location.state.academia : null
    const nombreAcademia = location.state ? location.state.nombreAcademia : null

    const secretKey = 'MuBG7678bHJ$4eGr83&%'

    const contentRef = useRef()

    const { data: fetchedData, loading: dataLoading, error: dataError } = usePlayersData(ref)

    //Variables del screen
    const [variables, setVariables] = useState({
        loading: true,

        subscriptions: [],
        players: [],
        classes: [],
        filteredPlayers: [],
        playersFiltered: [],

        selectedSub: null,
        showCalendar: false,

        //Variables para el control de filtros
        searchPlayer: "",
        filter: 0,
        nivel: "Todos",
        categoria: "Todos",
        rama: "Todos",
        subTotal: 0,
        subTotalT: 0,
        filtersApplied: false,
        sedes: [],
        sede: ""
    })

    //Variables para el control de modificaciones por conjunto
    const [ selectedPlayers, setSelectedPlayers ] = useState([])

    const [ticket, setTicket] = useState({
        show: false,
        forma_pago: "Efectivo",
        comentarios: "",
        data: null,
        dataPayment: null
    })

    //Variable para el selector de informacion
    const [ infoSelect, setInfoSelect ] = useState("Clases")

    //Variables para la creacion del comprobante
    const [ ticketData, setTicketData ] = useState({
        nombre_jugador: "",
        concepto_pago: "",
        cantidad_pago: 0,
        comentarios_pago: "",
        forma_pago: ""
    })

    //Variable unificada para el confirm
    const [confirm, setConfirm] = useState({
        show: false,
        title: "",
        text: "",
        onHandle: () => {}
    })

    //Variables para el control de la lista de pagos por actualizar
    const [ paymentsList, setPaymentsList ] = useState([])

    //Control del mensaje snack
    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")

        let snack = document.createElement("div")
        snack.classList.add("snack")

        snack.innerHTML = status == "success" ?
            "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
            "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
            "<div className='snackBar' style='background-color: #56d600;'></div>"
            : status == "warning" ?
                "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                : status == "error" ?
                    "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #c20000;'></div>"
                    : ""

        contSnack.appendChild(snack)
        setTimeout(() => {
            snack.remove()
        }, 5000)
    }

    const validatePaymentDay = (data) => validatePayment(data, "suscripciones_jugador_aux", variables.selectedSub)
    const validatePaymentDayColor = (data) => validatePayment(data, "suscripciones_jugador", variables.selectedSub)

    //Funcion padre para la separacion de jugadores
    const changeSubscription = async (subscription) => {
        let selectedPlayers = []
        let cantidadTotal = 0
        let cantidadTotalT = 0

        if (subscription != null) {
            await changeSubscriptionAux(subscription).then(r => {
                selectedPlayers = r.selectedPlayers
                cantidadTotal = r.cantidadTotal
                cantidadTotalT = r.cantidadTotalT
            })
        }

        setSelectedPlayers(prev => ([]))
        setVariables(prev => ({
            ...prev,
            loading: false,
            filtersApplied: false,
            searchPlayer: "",
            filter: 0,
            nivel: "Todos",
            categoria: "Todos",
            rama: "Todos",
            filteredPlayers: selectedPlayers,
            subTotal: cantidadTotal,
            subTotalT: cantidadTotalT
        }))
    }
    //Funcion que filtra a los jugadores y los muestra
    const changeSubscriptionAux = async (subscription) => {
        const selectedPlayers = []
        let cantidadTotal = 0
        let cantidadTotalT = 0

        for (let i = 0; i < variables.players.length; i++) {
            for (let j = 0; j < variables.players[i].suscripciones_jugador.length; j++) {
                if (variables.players[i].suscripciones_jugador[j].suscripcion === subscription.nombre_suscripcion) {

                    cantidadTotal += parseInt(variables.players[i].suscripciones_jugador[j].pagado)
                    cantidadTotalT += parseInt(variables.players[i].suscripciones_jugador[j].por_pagar)

                    selectedPlayers.push({
                        ...variables.players[i],
                        suscripciones_jugador: [{
                            ...variables.players[i].suscripciones_jugador[j]
                        }],
                        suscripciones_jugador_aux: [{
                            ...variables.players[i].suscripciones_jugador_aux[j]
                        }],
                        positionList: i,
                        positionSubscription: j
                    })

                    break
                }
            }
        }

        return { selectedPlayers, cantidadTotal, cantidadTotalT }
    }
    //Funcion que selecciona a todos los jugadores
    const getAllPlayers = async () => {
        const selectedPlayers = []

        for (let i = 0; i < variables.players.length; i++) {
            selectedPlayers.push({
                ...variables.players[i],
                positionList: i
            })
        }

        setVariables(prev => ({
            ...prev,
            filteredPlayers: selectedPlayers,
            loading: false,
            selectedSub: "Todos",
            filtersApplied: false,
            searchPlayer: "",
            filter: 0,
            nivel: "Todos",
            categoria: "Todos",
            rama: "Todos",
        }))
    }

    //FUNCION PARA FILTRAR JUGADORES, EN BASE A LOS DATOS QUE RECIBE
    const changeFilterSum = (filtro, valor) => {

        const filtros = {
            pago: variables.filter,
            rama: variables.rama,
            nivel: variables.nivel,
            categoria: variables.categoria,
            nombre: variables.searchPlayer
        }

        let cantidadTotal = 0
        let cantidadTotalT = 0

        //Obtenemos todos los filtros
        if(filtro === 0) {
            filtros.pago = valor
        } else if(filtro === 1){
            filtros.rama = valor
        } else if(filtro === 2){
            filtros.nivel = valor
        } else if(filtro === 3){
            filtros.categoria = valor
        } else if(filtro === 4){
            filtros.nombre = valor
        }

        //Una vez obteniendo todos los filtros en un solo objeto, ahora si filtramos a los jugadores
        //Primero filtramos por los filtros de menor complejidad, Rama, Nivel, Categoria y Nombre
        let newArray = variables.filteredPlayers.filter(v => 
            filtros.rama === "Todos" && filtros.nivel === "Todos" && filtros.categoria === "Todos" ?
                v
            : filtros.rama === "Todos" && filtros.nivel === "Todos" && filtros.categoria != "Todos" ?
                v.categoria_jugador === filtros.categoria
            : filtros.rama === "Todos" && filtros.nivel != "Todos" && filtros.categoria === "Todos" ?
                v.nivel_jugador === filtros.nivel
            : filtros.rama === "Todos" && filtros.nivel != "Todos" && filtros.categoria != "Todos" ?
                v.nivel_jugador === filtros.nivel && v.categoria_jugador === filtros.categoria
            : filtros.rama != "Todos" && filtros.nivel === "Todos" && filtros.categoria === "Todos" ?
                v.rama_jugador === filtros.rama
            : filtros.rama != "Todos" && filtros.nivel === "Todos" && filtros.categoria != "Todos" ?
                v.rama_jugador === filtros.rama && v.categoria_jugador === filtros.categoria
            : filtros.rama != "Todos" && filtros.nivel != "Todos" && filtros.categoria === "Todos" ?
                v.rama_jugador === filtros.rama && v.nivel_jugador === filtros.nivel
            :
                v.rama_jugador === filtros.rama && v.nivel_jugador === filtros.nivel && v.categoria_jugador === filtros.categoria
        )

        //Luego filtramos por nombre
        newArray = newArray.filter(v => v.nombre_jugador.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1").normalize().match(filtros.nombre.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1").normalize()))

        if(variables.selectedSub != "Todos"){
            newArray = newArray.map(v => {
                return {
                    ...v,
                    suscripciones_jugador_aux: v.suscripciones_jugador_aux.filter(r => r.suscripcion === variables.selectedSub.nombre_suscripcion)
                }
            })
            
            if(filtros.pago == 1){
                newArray = newArray.filter(v => validatePaymentDay(v) == PAYMENT_COLORS.PAID)
            } else if(filtros.pago == 2){
                newArray = newArray.filter(v => validatePaymentDay(v) == PAYMENT_COLORS.UNPAID)
            } else if(filtros.pago == 3){
                newArray = newArray.filter(v => validatePaymentDay(v) == PAYMENT_COLORS.PARTIAL)
            }
    
            //Ahora hacemos la sumatoria de los contadores
            for(let i = 0; i < newArray.length; i++){
                cantidadTotalT += parseFloat(newArray[i].suscripciones_jugador_aux[0].por_pagar)
                cantidadTotal += parseFloat(newArray[i].suscripciones_jugador_aux[0].pagado)
            }   
        }

        setVariables(prev => ({
            ...prev,
            subTotal: cantidadTotal,
            subTotalT: cantidadTotalT,
            filtersApplied: true,
            playersFiltered: newArray
        }))
    }

    //Funcion que actualiza las asistencias de todos los jugadores
    const resetAssitances = () => {
        setConfirm(prev => ({
            ...prev,
            show: false
        }))
        setVariables(prev => ({
            ...prev,
            loading: true
        }))

        setTimeout(() => {
            runUpdateAssistances()
        }, 500)
    }
    const runUpdateAssistances = async () => {
        try {
            await updateAssistances(ref, variables.players)
            setVariables(prev => ({ ...prev, loading: false }))
            setTimeout(() => { showMessage("Jugadores actualizados", "success") }, 100)
        } catch (e) {
            console.log(e)
            setVariables(prev => ({ ...prev, loading: false }))
            setTimeout(() => { showMessage("Error al reiniciar asistencias", "error") }, 100)
        }
    }

    //Funcion que actualiza los datos del jugador
    const onHandleUpdatePlayer = () => {
        setTicket(prev => ({
            ...prev,
            show: false
        }))

        const saveFinance = window.confirm("¿Deseas guardar el pago en la lista de finanzas?")
        let newFinanceObject = {}

        if(saveFinance){
            let financeNumber = window.prompt("Cantidad a registrar en el libro de finanzas: ",
                ticket.dataPayment.suscripciones_jugador[0].pagado
            )
    
            //Validamos si el numero recibido es un string vacio o null
            while(financeNumber === "" || financeNumber === null || parseInt(financeNumber) <= 0 || isNaN(financeNumber)){
                financeNumber = window.prompt("Ingresa una cantidad valida mayor a 0: ",
                    ticket.dataPayment.suscripciones_jugador[0].pagado
                )
            }
    
            newFinanceObject = {
                cantidad: parseInt(financeNumber),
                categoria: ticket.dataPayment.suscripciones_jugador[0].suscripcion,
                concepto: ticket.dataPayment.suscripciones_jugador[0].suscripcion + " " + ticket.data.nombre_jugador.split(" ").filter((v, i) => i <= 1).join(" ") 
            }
        }


        onHandleSave({
            dataPayment: ticket.dataPayment,
            ticket: ticket
        }, newFinanceObject, saveFinance)

    }

    const onHandleSave = async (data, financeData, saveFinance) => {
        try {
            const dataPayment = data.dataPayment
            const newSuscription = variables.players[dataPayment.positionList].suscripciones_jugador
            await updatingPlayer(ref, dataPayment.correo_jugador, newSuscription)

            const paymentData = {
                fecha_pago: dataPayment.suscripciones_jugador[0].fecha_pago,
                cantidad_pago: dataPayment.suscripciones_jugador[0].pagado,
                comentarios_pago: data.ticket.comentarios,
                concepto_pago: dataPayment.suscripciones_jugador[0].suscripcion,
                forma_pago: data.ticket.forma_pago
            }
            await addPaymentHistory(dataPayment.player_ref, paymentData)

            if (saveFinance === true) {
                await addNewFinance(ref, financeData, dataPayment.suscripciones_jugador[0].fecha_pago)
            }

            setTicketData(prev => ({
                ...prev,
                nombre_jugador: "",
                concepto_pago: "",
                cantidad_pago: 0,
                comentarios_pago: "",
                forma_pago: ""
            }))
            setTicket(prev => ({
                ...prev,
                show: false,
                data: null,
                dataPayment: null
            }))
            setTimeout(() => { showMessage("Pago actualizado correctamente", "success") }, 50)
        } catch (e) {
            console.log(e)
            setVariables(prev => ({ ...prev, loading: false }))
            setTimeout(() => { showMessage("Error al actualizar el pago", "error") }, 100)
        }
    }


    //Funcion que elimina a todos los jugadores de la lista
    const onHandleDeletePlayers = async () => {
        setConfirm(prev => ({ ...prev, show: false }))
        setVariables(prev => ({ ...prev, loading: true }))

        let cont = 0
        for (let i = 0; i < selectedPlayers.length; i++) {
            const jugador = variables.players.filter(d => d.id === selectedPlayers[i])[0]
            try {
                await deletingPlayer(ref, jugador.id)
                cont++
            } catch (e) {
                console.log(e)
            }
        }

        const deletedIds = selectedPlayers.slice()
        setSelectedPlayers([])
        setVariables(prev => ({
            ...prev,
            loading: false,
            players: prev.players.filter(p => !deletedIds.includes(p.id)),
            filteredPlayers: prev.filteredPlayers.filter(p => !deletedIds.includes(p.id)),
            playersFiltered: prev.playersFiltered.filter(p => !deletedIds.includes(p.id))
        }))
        if (cont === deletedIds.length) {
            setTimeout(() => { showMessage("Jugadores eliminados exitosamente", "success") }, 50)
        } else {
            setTimeout(() => { showMessage("No todos los jugadores se eliminaron correctamente", "warning") }, 50)
        }
    }

    //Funcion que da de baja a todos los jugadores de la lista
    const onHandleBajaPlayers = async () => {
        setConfirm(prev => ({ ...prev, show: false }))
        setVariables(prev => ({ ...prev, loading: true }))

        let cont = 0
        for (let i = 0; i < selectedPlayers.length; i++) {
            const jugador = variables.filteredPlayers.filter(d => d.id === selectedPlayers[i])[0]
            try {
                await bajaJugadorAction(ref, jugador)
                cont++
            } catch (e) {
                console.log(e)
            }
        }

        const bajaIds = selectedPlayers.slice()
        setSelectedPlayers([])
        setVariables(prev => ({
            ...prev,
            loading: false,
            players: prev.players.filter(p => !bajaIds.includes(p.id)),
            filteredPlayers: prev.filteredPlayers.filter(p => !bajaIds.includes(p.id)),
            playersFiltered: prev.playersFiltered.filter(p => !bajaIds.includes(p.id))
        }))
        if (cont === bajaIds.length) {
            setTimeout(() => { showMessage("Jugadores dados de baja exitosamente", "success") }, 50)
        } else {
            setTimeout(() => { showMessage("No todos los jugadores se dieron de baja correctamente", "warning") }, 50)
        }
    }

    //Funcion que reinicia los pagos de una sola suscripcion
    const updatePayments = () => {
        setConfirm(prev => ({ ...prev, show: false }))
        setVariables(prev => ({ ...prev, loading: true }))

        setTimeout(async () => {
            const allPlayers = variables.players.filter(jugadorA =>
                variables.filteredPlayers.some(jugadorB =>
                    jugadorA.correo_jugador === jugadorB.correo_jugador
                )
            )

            try {
                await generateSuscriptionXLSX(ref, allPlayers, variables.selectedSub.nombre_suscripcion)
                setVariables(prev => ({ ...prev, loading: false }))
                setTimeout(() => {
                    showMessage("Pagos reiniciados correctamente", "success")
                    setTimeout(() => { window.history.back() }, 2000)
                }, 100)
            } catch (e) {
                console.log(e)
                setVariables(prev => ({ ...prev, loading: false }))
                setTimeout(() => { showMessage("Error al reiniciar pagos", "error") }, 100)
            }
        }, 100)
    }

    //Funcion que crea un XLSX
    const hanldeCreateXLSX = () => {
        const players = variables.filtersApplied ? variables.playersFiltered : variables.filteredPlayers
        const success = handleCreateXLSX(players, variables.selectedSub)
        if (success) {
            showMessage("XLSX generado correctamente", "success")
        } else {
            showMessage("No hay jugadores para mostrar", "warning")
        }
    }

    useEffect(() => {
        if (!sessionStorage.getItem("homeFlag") || !ref) {
            navigate("/home", { replace: true })
            return
        }

        if (fetchedData && !dataLoading) {
            const selectedPlayers = fetchedData.players.map((p, i) => ({ ...p, positionList: i }))
            setVariables(prev => ({
                ...prev,
                subscriptions: fetchedData.subscriptions,
                players: fetchedData.players,
                classes: fetchedData.classes,
                sedes: fetchedData.sedes,
                contador: fetchedData.players.length,
                filteredPlayers: selectedPlayers,
                selectedSub: "Todos",
                filtersApplied: false,
                searchPlayer: "",
                filter: 0,
                nivel: "Todos",
                categoria: "Todos",
                rama: "Todos",
                sede: "",
                loading: false
            }))
        }

        if (dataError) {
            setVariables(prev => ({ ...prev, loading: false }))
            setTimeout(() => { showMessage("Error al cargar datos", "error") }, 100)
        }
    }, [fetchedData, dataLoading, dataError])

    if (variables.loading)
        return (
            <div>
                <Loader
                    loading={variables.loading}
                />
            </div>
        )

    if (!variables.loading) {
        const defaultSedeId = variables.sedes.find(s => s.es_default)?.id || variables.sedes[0]?.id || ""
        const sedeFilter = (list) => variables.sede
            ? list.filter(v => v.sede_default === variables.sede || (!v.sede_default && variables.sede === defaultSedeId))
            : list
        const displayFilteredPlayers = sedeFilter(variables.filteredPlayers)
        const displayPlayersFiltered = sedeFilter(variables.playersFiltered)

        return (
            <div className='mainPayments'>

                {/* COMPROBANTE DE PAGO */}
                <div className='body'
                    ref={contentRef}
                    style={{
                        width: '210mm',
                        height: '297mm',
                        padding: '20mm',
                        backgroundColor: 'white',
                        position: "absolute",
                        top: "-999999px",
                        fontFamily: fontType.text,
                        margin: 0,
                        padding: 20,
                        width: 800,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column"
                    }}
                >
                    {
                        <div className='ticket' style={{
                            border: "1px solid #ccc", 
                            borderRadius: 5,
                            padding: 20,
                            backgroundColor: "#f9f9f9",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                            width: "90%"
                        }}>
                            <img src={LogoTicket} style={{
                                width: 410,
                                height: 205,
                                marginBottom: 50
                            }} />
                            <h2 style={{
                                fontFamily: fontType.title,
                                fontSize: 20,
                                fontWeight: "bold",
                                color: "black",
                                marginTop: 0,
                                textAlign: "center",
                                justifyContent: "center"
                            }}>RECIBO DE PAGO ACADEMIA TENISTA</h2>
                            <p style={{ margin: "5px 0" }}>Fecha: <span style={{
                                textDecoration: "underline"
                            }}>{getCurrentDate()}</span></p>
                            <hr />
                            <p style={{ margin: "5px 0" }}>&nbsp;</p>
                            <div className='item' style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "70%",
                            }}>
                                <p style={{ margin: "5px 0" }}>Nombre:&nbsp;</p>
                                <p style={{ margin: "5px 0" }}><span style={{
                                    textDecoration: "underline"
                                }}>{ticketData.nombre_jugador}</span></p>
                            </div>
                            <div className='item' style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "70%",
                            }}>
                                <p style={{ margin: "5px 0" }}>Concepto:&nbsp;</p>
                                <p style={{ margin: "5px 0" }}><span style={{
                                    textDecoration: "underline"
                                }}>{ticketData.concepto_pago}</span></p>
                            </div>
                            <div className='item' style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "70%",
                            }}>
                                <p style={{ margin: "5px 0" }}>Cantidad:&nbsp;</p>
                                <p style={{ margin: "5px 0" }}>$<span style={{
                                    textDecoration: "underline"
                                }}>{ticketData.cantidad_pago}</span></p>
                            </div>
                            <div className='item' style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "70%",
                            }}>
                                <p style={{ margin: "5px 0" }}>Forma de pago:&nbsp;</p>
                                <p style={{ margin: "5px 0" }}><span style={{
                                    textDecoration: "underline"
                                }}>{ticketData.forma_pago}</span></p>
                            </div>
                            <div className='item' style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "70%",
                            }}>
                                <p style={{ margin: "5px 0" }}>Comentarios:&nbsp;</p>
                                <p style={{ margin: "5px 0" }}><span style={{
                                    textDecoration: "underline"
                                }}>{(ticketData.comentarios_pago === "" || ticketData.comentarios_pago === null) ? "Sin comentarios" : ticketData.comentarios_pago}</span></p>
                            </div>
                            <p style={{ margin: "5px 0" }}>&nbsp;</p>
                            <p style={{ margin: "5px 0" }}>&nbsp;</p>
                            <p className='footer' style={{
                                margin: "5px 0", 
                                fontStyle: "italic", 
                                width: "100%", 
                                textAlign: "center", 
                                justifyContent: "center"
                            }}>Recibo generado por aplicacion web</p>
                        </div>
                    }
                </div>
                {/*******************************************************/}

                <TicketModal
                    ticket={ticket}
                    setTicket={setTicket}
                    onHandleGenerateTicket={onHandleUpdatePlayer}
                />

                <Snack />

                <Confirm
                    confirm={confirm}
                    setConfirm={setConfirm}
                    onHandle={confirm.onHandle}
                />

                <h2 style={{
                    backgroundColor: main,
                    fontFamily: fontType.title,
                    paddingBottom: 0
                }}>PAGOS</h2>
                <h2 style={{
                    backgroundColor: main,
                    fontFamily: fontType.text,
                    marginTop: -40,
                    marginBottom: variables.sedes.length > 1 ? 10 : 40,
                    fontSize: 18,
                    padding: 10,
                    paddingBottom: 20,
                    paddingTop: 0
                }}>{
                    localStorage.getItem("authToken") ?
                        JSON.parse(localStorage.getItem("authToken")).nombre_academia
                    : ""
                }</h2>

                {variables.sedes.length > 1 && (
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 10,
                        marginBottom: 30,
                        padding: "10px 20px",
                        backgroundColor: "#f5f5f5",
                        borderRadius: 10,
                        width: "90%",
                        maxWidth: 500
                    }}>
                        <p style={{
                            fontFamily: fontType.title,
                            fontSize: 16,
                            margin: 0,
                            whiteSpace: "nowrap"
                        }}>SEDE:</p>
                        <select style={{
                            fontFamily: fontType.text,
                            padding: 8,
                            fontSize: 16,
                            borderRadius: 8,
                            border: "2px solid #ddd",
                            width: "100%",
                            cursor: "pointer",
                            outline: "none"
                        }}
                            value={variables.sede}
                            onChange={e => {
                                setVariables(prev => ({
                                    ...prev,
                                    sede: e.target.value
                                }))
                            }}
                        >
                            <option value="">Todas las sedes</option>
                            {variables.sedes.map(s => (
                                <option key={s.id} value={s.id}>{s.nombre_sede}</option>
                            ))}
                        </select>
                    </div>
                )}

                <Menu
                    academia={academia}
                    reference={ref}
                />

                <div className='contPagos'>

                    <button className='reiniciarpagos' style={{
                        backgroundColor: "rgb(100, 0, 0)",
                        fontFamily: fontType.title
                    }} onClick={() => {
                        if (!variables.selectedSub) {
                            showMessage("Debes seleccionar una suscripcion", "warning")
                        } else {
                            if(variables.selectedSub != "Todos" && variables.selectedSub != null){
                                setConfirm({
                                    text: "¿Estas seguro de reiniciar los pagos de esta suscripcion para todos los jugadores?" +
                                        " (Se generará un PDF con la informacion).",
                                    title: "Reiniciar pagos de " + variables.selectedSub.nombre_suscripcion,
                                    show: true,
                                    onHandle: updatePayments
                                })
                            } else {
                                showMessage("Debes seleccionar una suscripcion primero", "warning")
                            }
                        }
                    }}>REINICIAR PAGOS</button>

                    <div className='contFiltros'>
                        <div className='filtrosPagos'>
                            <div className='custom-select'>
                                <select placeholder='Seleccionar suscripcion'
                                    onChange={e => {
                                        if(e.target.value === "Todos"){
                                            setVariables(prev => ({
                                                ...prev,
                                                selectedSub: "Todos",
                                                loading: true
                                            }))
                                            setTimeout(() => {
                                                getAllPlayers()
                                            }, 100)
                                        } else {
                                            const itemValue = JSON.parse(e.target.value)

                                            setPaymentsList([])
                                            setVariables(prev => ({
                                                ...prev,
                                                selectedSub: itemValue,
                                                loading: true
                                            }))
                                            setTimeout(() => {
                                                changeSubscription(itemValue)
                                            }, 100)
                                        }
                                    }}
                                >
                                    <option value={null}>Seleccionar suscripcion</option>
                                    <option value={"Todos"}>Todas las suscripciones</option>
                                    {
                                        variables.subscriptions.map(v => {
                                            return (
                                                <option value={JSON.stringify(v)} >{v.nombre_suscripcion}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>

                            {
                                variables.selectedSub != "Todos" && (
                                    <div className='custom-select'>
                                        <select placeholder='Seleccionar suscripcion'
                                            onChange={e => {
                                                if(variables.selectedSub){

                                                    const t = e.target.value

                                                    setVariables(prev => ({
                                                        ...prev,
                                                        filter: t
                                                    }))

                                                    changeFilterSum(0, t)
                                                } else {
                                                    showMessage("Selecciona una suscripcion", "warning")
                                                }
                                            }}
                                        >
                                            <option value={0}>Seleccionar filtro</option>
                                            <option value={1}>Pagado</option>
                                            <option value={2}>No pagado</option>
                                            <option value={3}>Pendiente</option>
                                        </select>
                                    </div>
                                )
                            }

                            <div className='buttons-menu'>
                                <Link to={"/players/add"} state={{
                                    ref: ref
                                }} className='button-option' style={{
                                    backgroundColor: main,
                                    
                                }}>
                                    <IoPersonAddOutline size={30} />
                                    <p style={{
                                        fontFamily: fontType.subTitle,
                                        marginLeft: 10
                                    }}>AGREGAR JUGADOR</p>
                                </Link>
                                <Link to="/players/baja" state={{
                                    ref: ref,
                                    academia: academia
                                }} className='button-option' style={{
                                    backgroundColor: "orange"
                                }}>
                                    <LiaUserSlashSolid size={30} />
                                    <p style={{
                                        fontFamily: fontType.subTitle,
                                        marginLeft: 10
                                    }}>JUGADORES DE BAJA</p>
                                </Link>
                                <div className='button-option' style={{
                                    backgroundColor: "#770000"
                                }}
                                onClick={() => {
                                    setConfirm({
                                        show: true,
                                        title: "REINICIAR ASISTENCIAS",
                                        text: "Se reiniciaran las asistencias de todos los jugadores. ¿Quieres seguir?",
                                        onHandle: resetAssitances
                                    })
                                }}
                                >
                                    <RxReset size={30} />
                                    <p style={{
                                        fontFamily: fontType.subTitle,
                                        marginLeft: 10
                                    }}>REINICIAR ASISTENCIAS</p>
                                </div>

                                {
                                    selectedPlayers.length > 0 ?
                                        <p style={{
                                            width: "100%",
                                            textAlign: "center",
                                            fontSize: 18,
                                            fontFamily: fontType.title,
                                            marginTop: 40
                                        }}>JUGADORES SELECCIONADOS</p>
                                    : null
                                }
                                {
                                    selectedPlayers.length > 0 ?
                                        <div className='button-option' style={{
                                            backgroundColor: "orange"
                                        }}
                                        onClick={() => {
                                            setConfirm({
                                                title: "DAR DE BAJA JUGADORES",
                                                text: "¿Estas seguro de dar de baja " + selectedPlayers.length + " jugador(es)?",
                                                show: true,
                                                onHandle: onHandleBajaPlayers
                                            })
                                        }}
                                        >
                                            <p style={{
                                                fontFamily: fontType.subTitle
                                            }}>
                                                DAR DE BAJA ({selectedPlayers.length}) JUGADORES
                                            </p>
                                        </div>
                                    : null
                                }
                                
                                {
                                    selectedPlayers.length > 0 ?
                                        <div className='button-option' style={{
                                            backgroundColor: "#770000"
                                        }}
                                        onClick={() => {
                                            setConfirm({
                                                title: "ELIMINAR JUGADORES",
                                                text: "¿Estas seguro de eliminar permanentemente " + selectedPlayers.length + " jugador(es)?",
                                                show: true,
                                                onHandle: onHandleDeletePlayers
                                            })
                                        }}
                                        >
                                            <p style={{
                                                fontFamily: fontType.subTitle
                                            }}>
                                                ELIMINAR ({selectedPlayers.length}) JUGADORES
                                            </p>
                                        </div>
                                    : null
                                }
                                
                            </div>

                        </div>

                        <div className='filtrosJugadores'>
                            <p style={{
                                marginBottom: 10,
                                textAlign: "center",
                                fontFamily: fontType.text
                            }}><span style={{fontWeight: "bold"}}>Total:</span> {variables.filtersApplied ? displayPlayersFiltered.length : displayFilteredPlayers.length} jugadores</p>

                            <input
                                style={{
                                    fontFamily: fontType.text,
                                    width: "100%"
                                }}
                                className='playerinput'
                                placeholder="Buscar jugador"
                                value={variables.searchPlayer}
                                onChange={(e) => {
                                    const t = e.target.value

                                    setVariables(prev => ({
                                        ...prev,
                                        searchPlayer: t
                                    }))

                                    changeFilterSum(4, t)
                                }}
                            />

                            <div className='custom-select'>
                                <select id="Rama" name="Rama" style={{
                                    fontFamily: fontType.text
                                }}
                                    value={variables.rama}
                                    onChange={e => {
                                        const t = e.target.value

                                        setVariables(prev => ({
                                            ...prev,
                                            rama: t
                                        }))
    
                                        changeFilterSum(1, t)
                                    }}
                                >
                                    <option value="Todos">Todos</option>
                                    <option value="Varonil">Varonil</option>
                                    <option value="Femenil">Femenil</option>
                                </select>
                            </div>
                            <div>
                                <div className='custom-select'>
                                    <select id="Nivel" name="Nivel" style={{
                                        fontFamily: fontType.text
                                    }}
                                        value={variables.nivel}
                                        onChange={e => {
                                            const t = e.target.value

                                            setVariables(prev => ({
                                                ...prev,
                                                nivel: t
                                            }))
        
                                            changeFilterSum(2, t)
                                        }}
                                    >
                                        <option value="Todos">Todos</option>
                                        <option value="">Sin nivel</option>
                                        {
                                            niveles.map(v => {
                                                return (
                                                    <option value={v}>{v}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                                <div className='custom-select' style={{
                                    marginTop: 5
                                }}>
                                    <select id="Categoria" name="Categoria" style={{
                                        fontFamily: fontType.text
                                    }}
                                        value={variables.categoria}
                                        onChange={e => {
                                            const t = e.target.value
    
                                            setVariables(prev => ({
                                                ...prev,
                                                categoria: t
                                            }))
        
                                            changeFilterSum(3, t)
                                        }}
                                    >
                                        <option value="Todos">Todos</option>
                                        <option value="">Sin categoria</option>
                                        {
                                            categorias.map(v => {
                                                return (
                                                    <option value={v}>{v}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>

                            <button className='button-option' style={{
                                backgroundColor: "black",
                                width: "100%",
                                height: 70,
                                flexDirection: "row",
                                justifyContent: "center"
                            }} onClick={async () => {
                                const url = window.location.origin + "/489v57hniehrty9345hy/"
                                const ciphertext = CryptoJS.AES.encrypt(ref.toString() + "|" + (nombreAcademia ? nombreAcademia.toString() : "REGISTRO DE DATOS"), secretKey).toString().replace(/\//g, '_').replace(/\+/g, '-')
    
                                const newUrl = url + ciphertext
    
                                await navigator.clipboard.writeText(newUrl).then(r => {
                                    setTimeout(() => {
                                        showMessage("Link copiado correctamente", "success")
                                    }, 100)
                                }).catch( e => {
                                    setTimeout(() => {
                                        showMessage("No se ha podido copiar el link", "error")
                                    }, 100)
                                })
                            }}>
                                <IoPersonAddOutline size={30} />
                                <p style={{
                                    fontFamily: fontType.subTitle,
                                    marginLeft: 10
                                }}>COPIAR LINK</p>
                            </button>
    
                            <button style={{
                                backgroundColor: "white",
                                color: "black",
                                fontFamily: fontType.subTitle,
                                width: "100%",
                                border: "2px solid black"
                            }} className='button-option' onClick={hanldeCreateXLSX}>
                                CREAR XLSX
                            </button>

                        </div>
                    </div>

                    <div className='pagos' style={{
                        fontFamily: fontType.text
                    }}>
                        {
                            variables.selectedSub === null ?
                                <p style={{
                                    fontFamily: fontType.title,
                                    fontSize: 20,
                                    border: "1px solid black",
                                    borderRadius: 10,
                                    padding: 20
                                }}>SELECCIONA UNA SUSCRIPCION PARA COMENZAR</p>
                            :
                                <table className='table'>
                                    <tr>
                                        <th>
                                            <input
                                                type="checkbox"
                                                onChange={e => {
                                                    const visiblePlayers = variables.filtersApplied
                                                        ? displayPlayersFiltered
                                                        : displayFilteredPlayers
                                                    if (e.target.checked) {
                                                        setSelectedPlayers(visiblePlayers.map(v => v.id))
                                                    } else {
                                                        setSelectedPlayers([])
                                                    }
                                                }}
                                                checked={
                                                    (() => {
                                                        const visiblePlayers = variables.filtersApplied
                                                            ? displayPlayersFiltered
                                                            : displayFilteredPlayers
                                                        return visiblePlayers.length > 0 && selectedPlayers.length === visiblePlayers.length
                                                    })()
                                                }
                                            />
                                        </th>
                                        <th>Nombre</th>
                                        {
                                            variables.selectedSub != "Todos" && (<th>Por pagar<br/>($ {formatQuantity(variables.subTotalT)})</th>)
                                        }
                                        {
                                            variables.selectedSub != "Todos" && (<th>Pagado<br/>($ {formatQuantity(variables.subTotal)})</th>)
                                        }
                                        {
                                            variables.selectedSub != "Todos" && (<th>Fecha</th>)
                                        }
                                        {
                                            variables.selectedSub != "Todos" && (<th>Comentarios</th>)
                                        }
                                        <th>
                                            <div className='custom-select'>
                                                <select value={infoSelect} onChange={e => {
                                                    setInfoSelect(prev => e.target.value)
                                                }}>
                                                    <option value="Clases">Clases</option>
                                                    <option value="Asistencias">Asistencias</option>
                                                    <option value="Categoria">Categoria</option>
                                                    <option value="Correo">Correo</option>
                                                    <option value="Telefono">Telefono</option>
                                                    <option value="Edad">Edad</option>
                                                    <option value="FechaAlta">Fecha de alta</option>
                                                    <option value="Rama">Rama</option>
                                                    <option value="Ranking">Ranking</option>
                                                </select>
                                            </div>
                                        </th>
                                        {
                                            variables.selectedSub != "Todos" && (<th></th>)
                                        }
                                    </tr>
                                    {
                                        (variables.filtersApplied ? displayPlayersFiltered : displayFilteredPlayers).map((v, i) => (
                                            <Player
                                                key={v.id}
                                                v={v}
                                                i={i}
                                                navigate={navigate}
                                                reference={ref}
                                                variables={variables}
                                                setVariables={setVariables}
                                                setTicket={setTicket}
                                                showMessage={showMessage}
                                                validatePaymentDayColor={validatePaymentDayColor}
                                                infoSelect={infoSelect}
                                                academia={academia}
                                                selectedSub={variables.selectedSub}
                                                classes={variables.classes}
                                                navigation={navigate}
                                                selectedPlayers={selectedPlayers}
                                                setSelectedPlayers={setSelectedPlayers}
                                            />
                                        ))
                                    }
                                </table>
                        }
                    </div>

                </div>

            </div>
        )
    }
}

export default Players